import { escapeRegExp } from 'lodash-es';

import { sanitize } from '../../common/sanitizeString';

export const convertEnumCaseToSentenceCase = (enumCase = '', separator = ' ') =>
  enumCase
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(separator);

export const isLineClamped = (el: HTMLParagraphElement) =>
  el.scrollHeight > el.clientHeight;

export const addSpaceEveryXCharacters = (str: string, charCount: number) => {
  const removedSpace = str.replace(/\s/g, '');
  const regex = new RegExp(`.{${charCount}}`, 'g');
  return removedSpace.replace(regex, `$& `).trim();
};

export const splitBySearchValue = (
  label: string,
  searchValue: string,
  { matchFromStart }: { matchFromStart?: boolean } = {}
) => {
  if (!searchValue) {
    return {
      substrings: [label],
      searchValueIndex: -1,
    };
  }

  const unaccentedLabel = sanitize(label);
  const unaccentedSearchValue = sanitize(searchValue);
  const prefix = matchFromStart ? '\\b' : '';
  const unaccentedSubstrings = unaccentedLabel.split(
    new RegExp(`(${prefix}${escapeRegExp(unaccentedSearchValue)})`, 'gi')
  );
  const searchValueIndex = unaccentedSubstrings.findIndex(
    substring => substring === unaccentedSearchValue
  );

  const substrings = unaccentedSubstrings.map((str, i) => {
    const startFindIndexPosition = unaccentedSubstrings
      .slice(0, i)
      .join('').length;
    const startingIndex = unaccentedLabel.indexOf(str, startFindIndexPosition);
    return label.slice(startingIndex, startingIndex + str.length);
  });

  return {
    substrings,
    searchValueIndex,
  };
};
